/* The Prism Tree — page logic. Ported from the approved preview (preview-prism/index.html).
   Every price comes from window.PRISM, which Liquid builds from the real variants, so the page can never quote a number
   Shopify won't bill (STORE-BUILD-LESSONS §1). The cart is Shopify's cart: /cart.js, /cart/add.js, /cart/update.js,
   /cart/change.js, and the four wallet buttons + Checkout go to /checkout. */
(function () {
  var P = window.PRISM; if (!P) return;
  document.querySelectorAll('.ms').forEach(function (el) { el.setAttribute('aria-hidden', 'true'); });

  /* ---------- All products menu ---------- */
  var btn = document.getElementById('apBtn'), panel = document.getElementById('apPanel');
  if (btn && panel) {
    var setAp = function (open) { btn.setAttribute('aria-expanded', open ? 'true' : 'false'); panel.hidden = !open; };
    btn.addEventListener('click', function (e) { e.stopPropagation(); setAp(panel.hidden); });
    document.addEventListener('click', function (e) { if (!panel.hidden && !panel.contains(e.target)) setAp(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) { setAp(false); btn.focus(); } });
    var here = panel.querySelector('[aria-current="page"]');
    if (here) here.addEventListener('click', function (e) { e.preventDefault(); setAp(false); window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* ---------- gallery ---------- */
  var slides = [].slice.call(document.querySelectorAll('#stage .slide')), dots = document.getElementById('dots'),
      thumbs = [].slice.call(document.querySelectorAll('#thumbs button')), cur = 0;
  function go(i) {
    if (!slides.length) return;
    cur = (i + slides.length) % slides.length;
    slides.forEach(function (s, k) { s.classList.toggle('on', k === cur); });
    [].forEach.call(dots.children, function (d, k) { d.classList.toggle('on', k === cur); });
    thumbs.forEach(function (t, k) { t.classList.toggle('on', k === cur); });
  }
  slides.forEach(function (_, i) { var d = document.createElement('button'); d.type = 'button'; d.setAttribute('aria-label', 'Image ' + (i + 1)); d.onclick = function () { go(i); }; dots.appendChild(d); });
  document.querySelectorAll('.gnav').forEach(function (b) { b.onclick = function () { go(cur + Number(b.dataset.g)); }; });
  thumbs.forEach(function (t, k) { t.onclick = function () { go(k); }; });
  var sx = null, st = document.getElementById('stage');
  if (st) {
    st.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    st.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1)); sx = null; });
  }
  go(0);

  /* ========== REVIEWS — REAL ones only (last Christmas's Trustpilot). Empty = the section hides itself. ==========
     { name:'Linda B.', stars:5, text:'…', date:'Dec 2025', verified:true }   (verified only if tied to a real order) */
  var RV = (P.reviews && typeof P.reviews === 'object') ? P.reviews : {};   // from the product metafield hearthside.reviews
  var REVIEWS = (RV.items || []).filter(function (r) { return r && r.text && r.name; }).map(function (r) {
    return { name: String(r.name), text: String(r.text), stars: Math.max(1, Math.min(5, Math.round(Number(r.stars) || 5))), date: r.date ? String(r.date) : '', verified: !!r.verified };
  });
  var RATING = Number(RV.rating) > 0 ? Number(RV.rating) : null, REVIEW_COUNT = Number(RV.count) > 0 ? Math.round(Number(RV.count)) : null;
  var UGC = (RV.photos || []).filter(function (p) { return p && /^https:\/\//.test(String(p.src || '')); });

  /* ---------- prices: straight from the variants (cents in, dollars out) ---------- */
  var NAMES = { 1: 'The Centerpiece', 2: 'The Pair', 3: 'The Mantel Set' };
  var FIG = ['Tree', 'Reindeer', 'Snowman'];
  var PRICES = {}, EXTRA = null, BYID = {};
  Object.keys(P.sets).forEach(function (key) {
    var v = P.sets[key], k = [1, 2, 3].filter(function (n) { return NAMES[n] === v.set; })[0];
    BYID[v.id] = { kind: 'set', key: key };
    if (k && !PRICES[k]) PRICES[k] = { now: v.price / 100, reg: (v.compare > v.price ? v.compare : v.price) / 100 };
  });
  Object.keys(P.extras || {}).forEach(function (f) {
    var x = P.extras[f]; BYID[x.id] = { kind: 'extra', fig: f };
    if (!EXTRA) EXTRA = { now: x.price / 100, reg: (x.compare > x.price ? x.compare : x.price) / 100 };
  });
  var MAXQ = EXTRA ? 30 : 3;                       // sets of 4+ need the Extra-figure product (absent while it is a draft)

  /* ---------- the sale follows the STORE clock and the real compare-at prices ---------- */
  function storeDate(off) {
    var d = new Date(Date.now() + (off || 0));
    try { return new Intl.DateTimeFormat('en-CA', { timeZone: P.tz || 'America/Phoenix', year: 'numeric', month: '2-digit', day: '2-digit' }).format(d); }
    catch (e) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
  }
  var today = storeDate(), MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var hasCompare = [1, 2, 3].some(function (k) { return PRICES[k] && PRICES[k].reg > PRICES[k].now; });
  var saleOn = hasCompare && !!P.saleEnd && today <= P.saleEnd;
  var endLabel = today === P.saleEnd ? 'tonight' : (P.saleEnd ? MON[Number(P.saleEnd.slice(5, 7)) - 1] + ' ' + Number(P.saleEnd.slice(8, 10)) : '');
  document.querySelectorAll('[data-end-label]').forEach(function (el) { el.textContent = endLabel; });
  function money(n) { return '$' + n.toFixed(2); }
  function whole(n) { return '$' + (Math.round(n * 100) % 100 ? n.toFixed(2) : Math.round(n)); }
  var maxSave = saleOn ? Math.max.apply(null, [1, 2, 3].map(function (k) { return PRICES[k].reg - PRICES[k].now; })) : 0;
  if (!saleOn) document.querySelectorAll('.hhsale,.perk.sale,[data-sale-only]').forEach(function (el) { el.hidden = true; });
  else {                                           // the server ships the safe banner; the sale line appears only while it is real
    var bn = document.querySelector('.banner[data-sale-banner]');
    if (bn) bn.innerHTML = '<span class="sale">Preseason sale</span>Save up to <b>' + whole(maxSave) + '</b> &nbsp;·&nbsp; Ends <b>' + endLabel + '</b>';
    document.querySelectorAll('.hhsale b').forEach(function (b) { if (/^\$\d/.test(b.textContent)) b.textContent = whole(maxSave); });
  }
  if (P.xmasBy && today > P.xmasBy) {             // after the order-by date every Christmas-delivery promise switches off
    document.querySelectorAll('[data-xmas-yes]').forEach(function (e) { e.hidden = true; });
    document.querySelectorAll('[data-xmas-late]').forEach(function (e) { e.hidden = false; });
  }
  var apP = document.getElementById('apPrice'); if (apP) apP.textContent = 'Lit iridescent tree · from ' + money(PRICES[1].now);

  /* ---------- the bundle offer (Julian, 2026-10-08) ----------
     The Centerpiece is the single price. The Pair is "buy one, get one 50% off" and The Mantel Set "buy two, get one free", so a
     set's regular price is (figures × the single price); an Extra figure (4+) is compared with the single price too. The deal
     labels only show while the variant prices really make them true (to the cent), so a later price change can't leave a false claim. */
  var SINGLE = PRICES[1] ? PRICES[1].now : 0;
  [2, 3].forEach(function (k) { if (PRICES[k] && SINGLE) PRICES[k].reg = Math.max(PRICES[k].reg, Math.round(k * SINGLE * 100) / 100); });
  if (EXTRA && SINGLE) EXTRA.reg = Math.max(EXTRA.reg, SINGLE);
  function near(a, b, tol) { return Math.abs(a - b) <= tol + 1e-9; }
  var DEAL = {
    1: '',
    2: PRICES[2] && near(PRICES[2].now, SINGLE * 1.5, 0.01) ? 'Buy one, get one 50% off' : '',
    3: PRICES[3] && near(PRICES[3].now, SINGLE * 2, 0.02) ? 'Buy two, get one free' : ''
  };
  document.querySelectorAll('[data-deal]').forEach(function (d) { var t = DEAL[d.getAttribute('data-deal')]; d.textContent = t || ''; d.hidden = !t; });
  var hd = document.getElementById('hhdeal'); if (hd && !DEAL[2] && !DEAL[3]) hd.hidden = true;
  function figsOf(key) { var n = 0; String(key).split(' + ').forEach(function (p) { var mm = p.match(/^(\d+) ×/); n += mm ? Number(mm[1]) : (p ? 1 : 0); }); return n; }

  /* ---------- offer + picker ---------- */
  var FIGS = [['Tree', P.images.tree], ['Reindeer', P.images.reindeer], ['Snowman', P.images.snowman]];
  var tiers = [].slice.call(document.querySelectorAll('.tier')), fpick = document.getElementById('fpick'), fstat = document.getElementById('fstat'),
      atcTxt = document.getElementById('atcTxt'), stName = document.getElementById('stName'), stSub = document.getElementById('stSub'),
      stAtcTxt = document.getElementById('stAtcTxt');
  var picks = ['Tree', 'Tree'], q = 2, touched = false;   // touched: the shopper has changed the picker themselves
  var CART = null;

  tiers.forEach(function (t) {
    var k = Number(t.dataset.q), Pk = PRICES[k], save = Pk.reg - Pk.now;
    t.querySelector('.was').textContent = Pk.reg > Pk.now ? money(Pk.reg) : '';
    t.querySelector('.now').textContent = money(Pk.now);
    t.querySelector('.each').textContent = Pk.reg > Pk.now ? 'You save ' + money(Pk.reg - Pk.now) : '';
    t.querySelector('.sv').textContent = 'Preseason: save ' + whole(save);
  });

  function total(n, key) { return n <= 3 ? PRICES[n][key] : PRICES[3][key] + (n - 3) * (EXTRA ? EXTRA[key] : 0); }
  function setName(n) { return n <= 3 ? NAMES[n] : 'Your set of ' + n; }
  var t3 = tiers[2], t3def = { sub: t3.querySelector('.sub').innerHTML };
  function paintBig(n) {
    var k = Math.max(n, 3), now = total(k, 'now'), reg = total(k, 'reg');
    t3.querySelector('.sub').innerHTML = n > 3 ? n + ' figures · mix and match · every extra figure ' + whole(EXTRA.now) : t3def.sub;
    t3.querySelector('.now').textContent = money(now);
    t3.querySelector('.was').textContent = reg > now ? money(reg) : '';
    t3.querySelector('.each').textContent = reg > now ? 'You save ' + money(reg - now) : '';
    t3.querySelector('.sv').textContent = 'Preseason: save $' + Math.floor(reg - now + 1e-6);   // round DOWN: never overstate a saving
    t3.querySelectorAll('.perk').forEach(function (pk) {
      if (/storage cases/.test(pk.textContent)) pk.innerHTML = '<span class="ms" aria-hidden="true">check</span>' + k + ' hard storage cases';
      if (/gift boxes/.test(pk.textContent)) pk.innerHTML = '<span class="ms" aria-hidden="true">check</span>' + k + ' gift boxes &amp; cards';
    });
  }
  function countOf(f) { return picks.filter(function (x) { return x === f; }).length; }
  function counts() { var c = {}; FIG.forEach(function (f) { c[f] = countOf(f); }); return c; }
  function lineOf(c) { return FIG.map(function (f) { return c[f] ? (c[f] > 1 ? c[f] + ' × ' : '') + f : ''; }).filter(Boolean).join(' + '); }
  function figLine() { return lineOf(counts()); }
  var SIZE = { Tree: '19.7 in tall', Reindeer: '16.1 in tall', Snowman: '15.9 in tall' };
  function renderFigs() {
    var n = picks.length;
    fpick.innerHTML = FIGS.map(function (f) {
      var c = countOf(f[0]);                       // at 1 the minus becomes a delete: it takes that figure to 0
      var minus = c === 1 ? '<button type="button" class="qty__b del" data-act="-" data-f="' + f[0] + '" aria-label="Remove ' + f[0] + '"><span class="ms" aria-hidden="true">delete</span></button>'
                          : '<button type="button" class="qty__b" data-act="-" data-f="' + f[0] + '" aria-label="One less ' + f[0] + '"' + (c === 0 ? ' disabled' : '') + '>−</button>';
      return '<div class="frow' + (c ? ' on' : '') + '">' +
        '<span class="frow__ic"><img src="' + f[1] + '" alt="" width="48" height="48"></span>' +
        '<span class="frow__t"><b>' + f[0] + '</b><small>' + SIZE[f[0]] + '</small></span>' +
        '<span class="qty">' + minus + '<span class="qty__n">' + c + '</span>' +
        '<button type="button" class="qty__b" data-act="+" data-f="' + f[0] + '" aria-label="One more ' + f[0] + '"' + (n >= MAXQ ? ' disabled' : '') + '>+</button>' +
        '</span></div>';
    }).join('');
    var line;
    if (n === 0) line = '<span class="empty">No figures picked yet — tap + to add one.</span><span class="nudge">Start with one → ' + NAMES[1] + ', ' + money(PRICES[1].now) + '</span>';
    else {
      line = '<span><b>' + n + (n === 1 ? ' figure:' : ' figures:') + '</b> ' + figLine() + '</span>';
      if (n < 3) { var nx = n + 1; line += '<span class="nudge">Add ' + (nx === 2 ? 'a second' : 'a third') + ' → ' + (DEAL[nx] ? DEAL[nx].charAt(0).toLowerCase() + DEAL[nx].slice(1) : NAMES[nx] + ', ' + money(PRICES[nx].now)) + '</span>'; }
      else if (EXTRA && n < MAXQ) line += '<span class="nudge">Add another for just ' + whole(EXTRA.now) + '</span>';
    }
    fstat.innerHTML = line;
    fpick.querySelectorAll('.qty__b').forEach(function (b) {
      b.onclick = function () {
        var f = b.dataset.f; touched = true;
        if (b.dataset.act === '+') { if (picks.length < MAXQ) picks.push(f); }
        else if (picks.lastIndexOf(f) > -1) picks.splice(picks.lastIndexOf(f), 1);
        render();
        var again = fpick.querySelector('.qty__b[data-f="' + f + '"][data-act="' + b.dataset.act + '"]');
        if (again && !again.disabled) again.focus();
        else { again = fpick.querySelector('.qty__b[data-f="' + f + '"][data-act="+"]:not([disabled])') || fpick.querySelector('.qty__b[data-f="' + f + '"][data-act="-"]:not([disabled])'); if (again) again.focus(); }
      };
    });
  }
  function render() {
    if (picks.length > MAXQ) picks.length = MAXQ;  // never quote figures the store can't sell
    q = picks.length;
    tiers.forEach(function (x) { var on = Number(x.dataset.q) === Math.min(q, 3); x.classList.toggle('on', on); x.querySelector('input').checked = on; });
    renderFigs(); paintBig(q);
    var shown = Math.max(q, 1);                    // headline price = the selection's real total (one figure when nothing is picked)
    document.getElementById('fromPrice').textContent = money(total(shown, 'now'));
    var wr = total(shown, 'reg'), wn = total(shown, 'now');
    var wp = document.getElementById('wasPrice'); wp.textContent = wr > wn ? money(wr) : ''; wp.hidden = !(wr > wn);
    [document.getElementById('atc'), document.getElementById('stAtc')].forEach(function (a) { a.classList.toggle('off', q === 0); });
    if (q === 0) {
      atcTxt.textContent = 'Pick a figure to continue'; stAtcTxt.textContent = 'Pick a figure';
      stName.textContent = 'Choose your set'; stSub.textContent = 'Pick at least one figure';
      return;
    }
    paintAtc();
    stName.textContent = setName(q); stSub.textContent = figLine() + ' — ' + money(total(q, 'now'));
  }
  function askForFigure() {
    fpick.scrollIntoView({ behavior: 'smooth', block: 'center' });
    fpick.classList.remove('ask'); void fpick.offsetWidth; fpick.classList.add('ask');
    var plus = fpick.querySelector('.qty__b[data-act="+"]'); if (plus) setTimeout(function () { try { plus.focus({ preventScroll: true }); } catch (e) {} }, 350);
  }
  // a set card adds Trees or takes off the most recent picks until the count matches
  // (a keyboard pick fires the click on the radio itself — let that one through or the browser un-checks it again)
  tiers.forEach(function (t) {
    t.addEventListener('click', function (e) {
      if (e.target.tagName !== 'INPUT') e.preventDefault();
      touched = true;
      var n = Number(t.dataset.q);
      while (picks.length < n) picks.push('Tree'); while (picks.length > n) picks.pop(); render();
    });
  });
  var cp = document.getElementById('choosePair'); if (cp) cp.addEventListener('click', function () { tiers[1].click(); });

  /* ---------- reviews ---------- */
  (function () {
    var sec = document.getElementById('reviews'); if (!sec) return;
    var rsum = document.getElementById('rsum'), ugc = document.getElementById('ugc'),
        g1 = document.getElementById('rgrid'), g2 = document.getElementById('rgrid2'), more = document.getElementById('rmore');
    function esc(x) { return String(x).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function stars(n) { return '★★★★★'.slice(0, n) + '☆☆☆☆☆'.slice(0, 5 - n); }
    function card(r) { return '<figure class="rcard"><div class="s">' + stars(r.stars) + '</div><blockquote>' + esc(r.text) + '</blockquote><figcaption>' + esc(r.name) + (r.verified ? ' <span class="vb"><span class="ms" aria-hidden="true">check</span> Verified Buyer</span>' : '') + (r.date ? ' <span style="font-weight:400;color:var(--muted)">· ' + esc(r.date) + '</span>' : '') + '</figcaption></figure>'; }
    var rempty = document.getElementById('rempty'), rhead = document.getElementById('rhead');
    /* ?review-slots on the URL shows the localhost layout with labelled empty slots — a template for Julian to see exactly what to
       send (rating + count, 4 customer photos, 6 reviews). Never shown to shoppers: they never have that parameter. */
    if (!REVIEWS.length && /[?&]review-slots\b/.test(location.search)) {
      sec.hidden = false;
      var slot = function (i) { return '<figure class="rcard sample"><span class="stag">Empty slot ' + i + '</span><div class="s">★★★★★</div><blockquote>A real review from last Christmas goes here — the customer\'s own words, two or three sentences.</blockquote><figcaption>First name + last initial</figcaption></figure>'; };
      if (rempty) rempty.hidden = true;
      if (rhead) rhead.textContent = 'What people say the first time they switch it on';
      rsum.hidden = false; ugc.hidden = false;
      rsum.innerHTML = '<div class="rcard sample" style="padding:14px 20px;flex-direction:row;align-items:center;gap:14px"><span class="stag">Empty slot</span><div class="rnum" style="color:var(--faint)">–.–</div><div><div class="s">★★★★★</div><div class="rcount">Real rating + count from last year\'s Trustpilot</div></div></div>';
      ugc.innerHTML = [1, 2, 3, 4].map(function (i) { return '<figure class="ugcslot"><span class="ms" aria-hidden="true">add_a_photo</span><span>Customer photo ' + i + '</span></figure>'; }).join('');
      g1.innerHTML = [1, 2, 3].map(slot).join('');
      more.hidden = false; document.getElementById('rmoreSum').textContent = 'Read three more';
      g2.innerHTML = [4, 5, 6].map(slot).join('');
      return;
    }
    if (!REVIEWS.length) { sec.hidden = true; return; }   // v26: no real reviews yet, so the whole section stays hidden (never fake ones)
    sec.hidden = false;
    if (rempty) rempty.hidden = true;
    if (rhead) rhead.textContent = 'What people say the first time they switch it on';
    rsum.innerHTML = RATING ? '<div class="rnum">' + RATING.toFixed(1) + '</div><div><div class="s">' + stars(Math.round(RATING)) + '</div><div class="rcount">' + (REVIEW_COUNT || REVIEWS.length).toLocaleString() + ' reviews</div></div>' : '';
    if (!RATING) rsum.hidden = true;
    // customer photos: real ones only (from customers), never stock or AI
    if (UGC.length) ugc.innerHTML = UGC.slice(0, 8).map(function (p) { return '<figure class="ugcph"><img src="' + esc(p.src) + '" alt="' + esc(p.alt || 'Customer photo') + '" loading="lazy" width="400" height="500"></figure>'; }).join('');
    else ugc.hidden = true;
    g1.innerHTML = REVIEWS.slice(0, 3).map(card).join('');
    if (REVIEWS.length > 3) { more.hidden = false; g2.innerHTML = REVIEWS.slice(3).map(card).join(''); document.getElementById('rmoreSum').textContent = 'Read ' + (REVIEWS.length - 3) + ' more'; }
  })();

  /* ================= CART — Shopify's cart, drawn like the live Hearthside drawer =================
     Rules: the cart holds ONE Prism set that always equals the picker (Add replaces it, so N figures always bill total(N));
     a set of 4+ is The Mantel Set variant + Extra-figure lines, so checkout bills exactly the page price;
     Prism lines get Edit + Remove (no stepper — 3 × Centerpiece would be $269.97 against $199.99 for 3 figures);
     Heirloom kit lines keep the live stepper; add-ons get Remove; extras never ride alone. */
  var toast = document.getElementById('toast'), cartN = document.getElementById('cartN'), tt, busy = false, lastOpener = null;
  var walnote = document.getElementById('walnote'), WALNOTE = walnote ? walnote.textContent : '';
  var FAIL = 'We couldn’t update your cart. Please try again.';
  function el(id) { return document.getElementById(id); }
  function esc(x) { return String(x).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function say(msg) { if (!toast) return; toast.textContent = msg; toast.classList.add('on'); clearTimeout(tt); tt = setTimeout(function () { toast.classList.remove('on'); }, 3600); }
  var ICON_SHIELD = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 2.8 4.6 5.9v5.3c0 4.6 3.1 8.4 7.4 9.9 4.3-1.5 7.4-5.3 7.4-9.9V5.9L12 2.8Z"/><path d="m8.9 11.9 2.2 2.2 4.1-4.4"/></svg>';
  var ICON_MEDAL = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="14.6" r="5.4"/><path d="m8.6 9.6 -2.4-6.4h11.6l-2.4 6.4"/><path d="M12 12.2v4.8"/><path d="M10.2 14.6h3.6"/></svg>';
  var UPSELLS = [
    { tag: 'protection', name: 'Shipping protection', icon: ICON_SHIELD, blurb: 'Lost, stolen or damaged in transit and we send another one.' },
    { tag: 'warranty', name: 'Lifetime warranty', icon: ICON_MEDAL, blurb: 'If a light stops working or a part breaks, we replace it free.' }
  ].filter(function (u) { return P.bumps && P.bumps[u.tag] && P.bumps[u.tag].id; });
  var BUMPID = {}; UPSELLS.forEach(function (u) { BUMPID[P.bumps[u.tag].id] = u; });

  function post(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
  }
  function okOrThrow(r) {
    if (r.ok) return r.json();
    return r.json().catch(function () { return null; }).then(function (j) { throw new Error((j && (j.description || j.message)) || FAIL); });
  }
  function refresh() {
    return fetch(P.routes.cartjs, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(FAIL); return r.json(); })
      .then(function (c) { CART = c; return c; });
  }
  function items() { return (CART && CART.items) || []; }
  function isSet(it) { return Number(it.product_id) === Number(P.productId); }
  function isExtra(it) { return P.extraProductId && Number(it.product_id) === Number(P.extraProductId); }
  function isPrism(it) { return isSet(it) || isExtra(it); }
  function isBump(it) { return !!BUMPID[it.variant_id]; }
  /* Christmas in a Bottle (port audit 2026-10-20): a bottle line (SKU HH-BOTTLE-*) is one tier, so it gets Remove only, never the kit
     stepper. The Pair / The Family Set (HH-BOTTLE-2/-3) include shipping protection free: the paid one is neither offered nor kept. */
  function isBottle(it) { return String((it && it.sku) || '').indexOf('HH-BOTTLE') === 0; }
  function freeBottle() { return items().some(function (it) { return /^HH-BOTTLE-[23]/.test(String(it.sku || '')); }); }
  /* The bottle stepper (2026-10-21, Julian: "up and down quantity and delete, just like the Heirloom Tree kit"): the kit stepper's
     look, but the number is BOTTLES and +/- swap the line's variant: 1 The Single, 2 The Pair, 3 The Family Set. Plus is disabled at
     three; at one bottle the minus is the delete icon; a sold-out tier is skipped. Tiers from window.HHBOTTLE (layout/prism.liquid ->
     snippets/hh-bottle-json); without it the line keeps Remove only. */
  var BOT_PROP_K = 'Shipping protection', BOT_PROP_V = 'Included free';
  function botTiers() { var b = P.bottle || window.HHBOTTLE; return (b && b.tiers) || null; }
  function botTierOf(it) { var ts = botTiers(); return (ts && it && ts[String(it.variant_id)]) || null; }
  function botByN(n) { var ts = botTiers(), k; if (ts) for (k in ts) if (ts[k] && ts[k].id && Number(ts[k].n) === Number(n)) return ts[k]; return null; }
  function botWord(n) { return n + (Number(n) === 1 ? ' bottle' : ' bottles'); }
  function botUp(n) { for (var j = n + 1; j <= 3; j++) { var t = botByN(j); if (t && t.available !== false) return t; } return null; }
  function botDown(n) { for (var j = n - 1; j >= 1; j--) { var t = botByN(j); if (t && t.available !== false) return t; } return null; }
  function bottleStepHTML(it) {
    var cur = botTierOf(it), n = cur ? Number(cur.n) || 0 : 0; if (!n) return '';
    var up = botUp(n), dn = botDown(n), nx = botByN(n + 1), off = busy ? ' disabled' : '';
    var minus = dn ? '<button class="hhci__b" type="button" data-hh-bstep="' + dn.n + '" data-dir="down" aria-label="Fewer bottles: switch to ' + esc(dn.name || botWord(dn.n)) + ', ' + botWord(dn.n) + '"' + off + '>&minus;</button>'
                   : '<button class="hhci__b" type="button" data-hh-q="0" data-dir="down" aria-label="' + (n === 1 ? 'Remove your bottle' : 'Remove your bottles') + '"' + off + '><span class="ms" aria-hidden="true">delete</span></button>';
    var plus = up ? '<button class="hhci__b" type="button" data-hh-bstep="' + up.n + '" data-dir="up" aria-label="More bottles: switch to ' + esc(up.name || botWord(up.n)) + ', ' + botWord(up.n) + '"' + off + '>+</button>'
                  : '<button class="hhci__b" type="button" data-dir="up" disabled aria-label="' + (n >= 3 || !nx ? 'Three bottles is the biggest set' : esc(nx.name || botWord(nx.n)) + ' is sold out right now') + '">+</button>';
    return '<span class="hhci__step" data-hh-bottle>' + minus + '<input class="hhci__n" type="text" value="' + n + '" readonly tabindex="-1" aria-label="Bottles">' + plus + '</span>';
  }
  function botFree(it) { return !!(it && it.properties && it.properties[BOT_PROP_K] === BOT_PROP_V); }
  // the swap = the bottle page's write (bottle.js syncSet): on a FRESH cart add the new tier first (with "Shipping protection:
  // Included free" for 2-3 bottles), then ONE /cart/update.js clearing every other bottle line and, for 2-3 bottles, a paid
  // protection; a refused add changes nothing. Then re-read: one bottle line of that tier at quantity 1, at the page's price.
  function swapBottle(n) {
    var t = botByN(n), free = Number(n) >= 2;
    if (!t) return Promise.reject(new Error(FAIL));
    return refresh().then(function () {
      var have = items().filter(isBottle);
      var keep = have.filter(function (it) { return Number(it.variant_id) === Number(t.id) && botFree(it) === free; })[0] || null;
      var upd = {}, need = false;
      have.forEach(function (it) { if (it !== keep) { upd[it.key] = 0; need = true; } });
      if (keep && Number(keep.quantity) !== 1) { upd[keep.key] = 1; need = true; }
      if (free) items().forEach(function (it) { if (isBump(it) && BUMPID[it.variant_id].tag === 'protection') { upd[it.key] = 0; need = true; } });
      var item = { id: Number(t.id), quantity: 1 };
      if (free) { item.properties = {}; item.properties[BOT_PROP_K] = BOT_PROP_V; }
      var step = keep ? Promise.resolve() : post(P.routes.add, { items: [item] }).then(okOrThrow);
      return step.then(function () { return need ? post(P.routes.update, { updates: upd }).then(okOrThrow) : null; }).then(refresh);
    }).then(function (c) {
      var b = items().filter(isBottle);
      if (b.length !== 1 || Number(b[0].variant_id) !== Number(t.id) || Number(b[0].quantity) !== 1 || botFree(b[0]) !== free) throw new Error(FAIL);
      if (Number(b[0].original_line_price) !== Number(t.price)) { var er = new Error(PRICE_MOVED); er.moved = true; throw er; }
      return c;
    });
  }
  // a bottle line is ONE line at quantity 1: a cart holding more (quantity 2 from an old page, or two lines after a failed clear)
  // becomes the tier for all its bottles, capped at three. Silent, on load only; never more bottles, never a higher bill.
  // One write in flight (review 2026-10-21): two swaps at once both add the new tier and Shopify merges them (The Pair x2,
  // $134.98 for 4 bottles). So the merge holds busy while it writes (a stepper click is refused), and if a write is already in
  // flight (a + on the drawer restored by Back, before the re-read answered) the merge stands aside: that swap clears every
  // other bottle line itself.
  function normalizeBottles() {
    var b = items().filter(isBottle), n = 0, known = true;
    if (busy || !botTiers() || !b.length || (b.length === 1 && Number(b[0].quantity) === 1)) return Promise.resolve();
    b.forEach(function (it) { var t = botTierOf(it); if (t) n += Number(t.n) * (Number(it.quantity) || 0); else known = false; });
    var to = botByN(Math.min(3, n));
    if (!known || !to || to.available === false) return Promise.resolve();
    setBusy(true); if (cartOpen()) renderCart();   // one write in flight: a stepper click during the merge would race it
    return swapBottle(to.n).catch(function () { return refresh().catch(function () {}); }).then(function () { setBusy(false); });
  }
  // 2 or 3 bottles: the shipping protection is part of the order at no charge, shown as its own row (as on the bottle page and /cart)
  function freeProtRowHTML() {
    var b = items().filter(function (it) { return /^HH-BOTTLE-[23]/.test(String(it.sku || '')); })[0]; if (!b) return '';
    var t = botTierOf(b), name = (t && t.name) || ((b.variant_title && b.variant_title !== 'Default Title') ? b.variant_title : ''), pp = P.bumps && P.bumps.protection;
    return '<div class="hhci" data-hh-free-prot><div class="hhci__im is-icon">' + ICON_SHIELD + '</div>' +
             '<div class="hhci__d"><div class="hhci__t">Shipping protection</div><div class="hhci__v">Included free' + (name ? ' with ' + esc(name) : '') + '</div></div>' +
             '<div class="hhci__p">' + (pp && pp.price ? '<s>' + money(pp.price / 100) + '</s>' : '') + 'Free</div></div>';
  }

  // the picker's set as cart items: 1–3 figures = one set variant; 4+ = The Mantel Set (a fixed, deterministic 3) + extras
  function wanted() {
    var c = counts(), n = picks.length; if (!n) return null;
    if (n <= 3) { var v = P.sets[lineOf(c)]; return v ? [{ id: v.id, quantity: 1 }] : null; }
    if (!EXTRA) return null;
    var base = { Tree: 0, Reindeer: 0, Snowman: 0 }, i = 0, guard = 0;
    while (base.Tree + base.Reindeer + base.Snowman < 3 && guard++ < 30) { var f = FIG[i % 3]; if (base[f] < c[f]) base[f]++; i++; }
    var sv = P.sets[lineOf(base)]; if (!sv) return null;
    var out = [{ id: sv.id, quantity: 1 }];
    for (var k = 0; k < FIG.length; k++) {
      var r = c[FIG[k]] - base[FIG[k]];
      if (r > 0) { var x = P.extras[FIG[k]]; if (!x) return null; out.push({ id: x.id, quantity: r }); }
    }
    return out;
  }
  function sig(list) { var m = {}; list.forEach(function (x) { var id = x.variant_id || x.id; m[id] = (m[id] || 0) + x.quantity; }); return Object.keys(m).sort().map(function (k) { return k + 'x' + m[k]; }).join(','); }
  function cartPrism() { return items().filter(isPrism); }
  function sameAsPicker() { var w = wanted(); return !!w && sig(cartPrism()) === sig(w); }

  // put the picker's set in the cart, replacing any Prism set already there.
  // Always decided on a FRESH cart (another tab, Back from another page, a first read still in flight), and the swap is ONE
  // /cart/update.js request — lines already there are set by key, new variants added by id — so a failure leaves the old set intact.
  var PRICE_MOVED = 'Prices just updated — refreshing the page.';
  function syncSet() {
    var want = wanted();
    if (!want) return Promise.reject(new Error(FAIL));
    return refresh().then(function () {
      var have = cartPrism();
      var done = (have.length && sig(have) === sig(want)) ? Promise.resolve(CART) : (function () {
        if (!have.length) return post(P.routes.add, { items: want }).then(okOrThrow).then(refresh);
        var wantQ = {}; want.forEach(function (w) { wantQ[w.id] = (wantQ[w.id] || 0) + w.quantity; });
        var upd = {};
        have.forEach(function (it) { upd[it.key] = wantQ[it.variant_id] || 0; delete wantQ[it.variant_id]; });
        Object.keys(wantQ).forEach(function (id) { upd[id] = wantQ[id]; });
        return post(P.routes.update, { updates: upd }).then(okOrThrow).then(refresh);
      })();
      return done.then(function (c) {
        if (sig(cartPrism()) !== sig(want)) throw new Error(FAIL);
        // the button quoted a price; if Shopify bills a different one (prices changed after this page loaded), stop here
        var billed = cartPrism().reduce(function (a, it) { return a + Number(it.final_line_price); }, 0);
        if (billed !== Math.round(total(q, 'now') * 100)) { var er = new Error(PRICE_MOVED); er.moved = true; throw er; }
        return c;
      });
    });
  }
  // picker mirrors a Prism set that is already in the cart (so Edit and "Update cart" mean what they say)
  function adoptCartSet() {
    var c = { Tree: 0, Reindeer: 0, Snowman: 0 }, any = false;
    items().forEach(function (it) {
      var m = BYID[it.variant_id]; if (!m) return; any = true;
      if (m.kind === 'set') m.key.split(' + ').forEach(function (part) { var mm = part.match(/^(\d+) × (.+)$/); if (mm) c[mm[2]] += Number(mm[1]) * it.quantity; else c[part] += it.quantity; });
      else c[m.fig] += it.quantity;
    });
    if (!any || touched) return;                  // never overwrite picks the shopper already made
    if (c.Tree + c.Reindeer + c.Snowman > MAXQ) return;   // an oversized cart set: keep the default picks; Update replaces it
    picks = []; FIG.forEach(function (f) { for (var i = 0; i < c[f]; i++) picks.push(f); });
    render();
  }

  function setBusy(on) {
    busy = on;
    ['hh-drawer', 'wallets'].forEach(function (id) { var nd = el(id); if (nd) { if (on) nd.setAttribute('aria-busy', 'true'); else nd.removeAttribute('aria-busy'); } });
    ['atc', 'stAtc'].forEach(function (id) { var b = el(id); if (b) { if (on) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled'); } });
  }
  function shownCount() { return items().reduce(function (a, it) { return a + (isExtra(it) ? 0 : (Number(it.quantity) || 0)); }, 0); }  // a set + its extras = 1 item
  function paintBadge() { var n = CART ? shownCount() : 0; if (cartN) { cartN.hidden = !n; cartN.textContent = n; } }
  function paintAtc() {
    if (q === 0) return;
    var upd = cartPrism().length > 0 && !sameAsPicker();
    atcTxt.textContent = (upd ? 'Update cart — ' : 'Add to cart — ') + money(total(q, 'now'));
    stAtcTxt.textContent = upd ? 'Update cart' : 'Add to cart';
  }
  function compareOf(it) {                         // per-unit compare-at in cents, only where it is honest to show it
    var m = BYID[it.variant_id];
    if (m) {                                       // Prism lines: the bundle's regular price (figures × the single price), always
      var reg = Math.round((m.kind === 'set' ? figsOf(m.key) : 1) * SINGLE * 100);
      return reg > Number(it.price) ? reg : 0;
    }
    var k = P.compare && P.compare[String(it.variant_id)]; return k && k > it.price ? k : 0;
  }
  function rowHTML(it) {
    var qty = Number(it.quantity) || 0, m = BYID[it.variant_id], bump = BUMPID[it.variant_id], ctl, vt = '', img = '';
    var cmp = compareOf(it), was = cmp ? '<s>' + money(cmp * qty / 100) + '</s>' : '';
    if (m && m.kind === 'set') {
      var setFigs = 0; m.key.split(' + ').forEach(function (p) { var mm = p.match(/^(\d+) ×/); setFigs += mm ? Number(mm[1]) : 1; });
      var xtra = 0; items().forEach(function (x) { var mx = BYID[x.variant_id]; if (mx && mx.kind === 'extra') xtra += x.quantity; });
      vt = P.sets[m.key].set + ' · ' + m.key + (xtra ? ' · set of ' + (setFigs + xtra) : '') + (qty > 1 ? ' · × ' + qty : '');
      var ff = m.key.split(' + ')[0].replace(/^\d+ × /, '').toLowerCase();   // the first picked figure, as in the approved design
      img = P.images[ff] || it.image || P.images.thumb;
      ctl = '<span class="hhci__acts"><button class="hhci__rm" type="button" data-hh-edit aria-label="Edit figures">Edit</button>' +
            '<button class="hhci__rm" type="button" data-hh-prism-rm aria-label="Remove your Prism Tree set">Remove</button></span>';
    } else if (m && m.kind === 'extra') {
      vt = 'Extra ' + m.fig + (qty > 1 ? ' × ' + qty : '') + ' · part of your set';
      img = P.images[m.fig.toLowerCase()] || P.images.thumb; ctl = '';
    } else if (bump) {
      ctl = '<button class="hhci__rm" type="button" data-hh-q="0" aria-label="Remove ' + esc(bump.name) + '">Remove</button>';
    } else if (isBottle(it)) {
      vt = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
      img = it.image || '';
      ctl = bottleStepHTML(it) || '<button class="hhci__rm" type="button" data-hh-q="0" aria-label="Remove your bottles">Remove</button>';
    } else {
      vt = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
      img = it.image || '';
      ctl = '<span class="hhci__step">' +
              '<button class="hhci__b" type="button" data-hh-q="' + (qty - 1) + '" aria-label="' + (qty > 1 ? 'Decrease quantity' : 'Remove this item') + '">' + (qty > 1 ? '&minus;' : '<span class="ms" aria-hidden="true">delete</span>') + '</button>' +
              '<input class="hhci__n" type="number" inputmode="numeric" min="1" max="10" value="' + qty + '" data-hh-qty aria-label="Quantity">' +
              '<button class="hhci__b" type="button" data-hh-q="' + (qty + 1) + '" aria-label="Increase quantity"' + (qty >= 10 ? ' disabled' : '') + '>+</button>' +
            '</span>';
    }
    var title = m && m.kind === 'extra' ? 'The Prism Tree' : it.product_title;
    return '<div class="hhci" data-hh-key="' + esc(it.key) + '">' +
             '<div class="hhci__im' + (bump ? ' is-icon' : '') + '">' + (bump ? bump.icon : (img ? '<img src="' + esc(img) + '" alt="">' : '<span class="ms" aria-hidden="true">redeem</span>')) + '</div>' +
             '<div class="hhci__d"><div class="hhci__t">' + esc(title) + '</div>' + (vt ? '<div class="hhci__v">' + esc(vt) + '</div>' : '') + (ctl ? '<div class="hhci__c">' + ctl + '</div>' : '') + '</div>' +
             '<div class="hhci__p">' + money(Number(it.final_line_price) / 100) + was + '</div>' +
           '</div>';
  }
  function renderCart() {
    var list = items(), sets = list.filter(isSet), extras = list.filter(isExtra), bumps = list.filter(isBump),
        kits = list.filter(function (it) { return !isPrism(it) && !isBump(it); });
    var n = CART ? Number(CART.item_count) || 0 : 0;
    var saved = list.reduce(function (a, it) { var c = compareOf(it); return a + (c ? (c - it.price) * it.quantity : 0); }, 0) / 100;
    // bottle lines after the Prism set, then their free shipping-protection row; a cart without bottles is drawn as before
    el('hh-lines').innerHTML = list.length ? sets.concat(extras).map(rowHTML).join('') + kits.filter(isBottle).map(rowHTML).join('') + freeProtRowHTML() +
                                             kits.filter(function (it) { return !isBottle(it); }).concat(bumps).map(rowHTML).join('') :
      '<div class="hhcart__empty"><span class="ms" aria-hidden="true">shopping_bag</span><p>Your cart is empty.</p><p class="s">Pick your figures to get started.</p><button class="hhcart__link" type="button" data-hh-shop>Choose your set</button></div>';
    var sc = shownCount(); el('hh-count').textContent = sc ? ' · ' + sc + (sc === 1 ? ' item' : ' items') : '';
    el('hh-total').textContent = money((CART ? Number(CART.items_subtotal_price) || 0 : 0) / 100);
    el('hh-save').hidden = !(saved > 0); el('hh-savev').textContent = '−' + money(saved);
    var go2 = el('hh-checkout'); go2.disabled = !n || busy;
    var ship = el('hh-ship'); ship.textContent = n ? 'Free' : '—'; ship.className = n ? 'is-free' : '';
    var urg = el('hh-urg');
    if (!n) urg.hidden = true;
    else {
      el('hh-urgt').innerHTML = saved > 0 ? '<span class="hhcart__saletag"><span class="ms" aria-hidden="true">redeem</span> Bundle savings</span>' +
        '<span class="hhcart__saletxt">You’re saving <b>' + money(saved) + '</b> on this order.</span>' : '';
      el('hh-urgs').innerHTML = '<span class="ms" aria-hidden="true">check</span> Free shipping included on your order.';
      urg.hidden = false;
    }
    var freeProt = freeBottle(), realKits = kits.filter(function (it) { return !isBottle(it); });
    var ups = UPSELLS.filter(function (u) { return !(u.tag === 'protection' && freeProt) && !(u.tag === 'warranty' && !sets.length && !realKits.length); });
    el('hh-upslist').innerHTML = ups.map(function (u) {
      var on = bumps.some(function (b) { return BUMPID[b.variant_id] === u; });
      return '<label class="hhup' + (on ? ' on' : '') + '" data-hh-up="' + u.tag + '"><input type="checkbox"' + (on ? ' checked' : '') + (busy ? ' disabled' : '') + '>' +
             '<span class="hhup__ico">' + u.icon + '</span><span class="hhup__box"><span class="ms" aria-hidden="true">check</span></span>' +
             '<span class="hhup__t"><b>' + u.name + '</b><small>' + u.blurb + '</small></span><span class="hhup__p">+' + money(P.bumps[u.tag].price / 100) + '</span></label>';
    }).join('');
    el('hh-ups').hidden = !(sets.length + kits.length) || !ups.length;
    paintBadge(); paintAtc();
  }
  // an Extra-figure line with no set beside it would sell a figure at $66.66 — take it out
  function guardOrphans() {
    var list = items(), upd = {}, any = false;
    if (!list.some(isSet)) list.filter(isExtra).forEach(function (it) { upd[it.key] = 0; any = true; });
    if (freeBottle()) list.filter(function (it) { return isBump(it) && BUMPID[it.variant_id].tag === 'protection'; }).forEach(function (it) { upd[it.key] = 0; any = true; });   // included free with 2-3 bottles
    if (!any) return Promise.resolve();
    return post(P.routes.update, { updates: upd }).then(okOrThrow).then(refresh);
  }

  var BEHIND = '.banner,header.site,main,footer.site-foot,#sticky';
  function behindInert(on) { document.querySelectorAll(BEHIND).forEach(function (nd) { if (on) nd.setAttribute('inert', ''); else nd.removeAttribute('inert'); }); }
  function openCart(opener) {
    lastOpener = (opener && opener !== document.body) ? opener : el('atc');   // Safari doesn't focus clicked buttons
    renderCart(); behindInert(true);
    el('hh-scrim').classList.add('on'); var dr = el('hh-drawer'); dr.classList.add('on'); dr.setAttribute('aria-hidden', 'false');
    try { el('hh-close').focus({ preventScroll: true }); } catch (e) {}
  }
  function closeCart() {
    el('hh-scrim').classList.remove('on'); var dr = el('hh-drawer'); dr.classList.remove('on'); dr.setAttribute('aria-hidden', 'true');
    behindInert(false);                            // before refocusing: focus() on an inert element silently fails
    if (lastOpener && document.contains(lastOpener)) try { lastOpener.focus({ preventScroll: true }); } catch (e) {}
  }
  function cartOpen() { return el('hh-drawer').classList.contains('on'); }
  function run(p, after) {                         // one write in flight; the drawer dims, never blanks
    if (busy) return Promise.resolve();
    setBusy(true); renderCart();
    return p().catch(function (err) { say((err && err.message) || FAIL); return refresh().catch(function () {}); })
      .then(function () { setBusy(false); renderCart(); if (after) after(); });
  }

  function addSet(e) {                             // main + sticky button: put the picker's set in the cart, open the drawer
    if (q === 0) { askForFigure(); return; }
    var opener = e && e.currentTarget;
    var moved = false;
    run(function () { return syncSet().catch(function (err) { if (err && err.moved) moved = true; throw err; }); },
        function () { if (moved) setTimeout(function () { location.reload(); }, 1200); else openCart(opener); });
  }
  function expressBuy() {                          // the four wallet buttons: the same set, then straight to checkout
    if (q === 0) { askForFigure(); return; }
    if (busy) return;
    if (walnote) { walnote.textContent = 'Taking you to checkout…'; walnote.classList.add('fired'); }
    setBusy(true);
    syncSet().then(function () { location.href = P.routes.checkout; })
      .catch(function (err) {
        say((err && err.message) || FAIL);
        if (err && err.moved) { setTimeout(function () { location.reload(); }, 1200); return; }
        setBusy(false); if (walnote) { walnote.textContent = WALNOTE; walnote.classList.remove('fired'); }
        refresh().catch(function () {}).then(renderCart);
      });
  }
  function goCheckout() {
    if (busy || !CART || !Number(CART.item_count)) return;
    var b = el('hh-checkout'); if (b) { b.disabled = true; b.innerHTML = '<span class="ms" aria-hidden="true">lock</span> Taking you to checkout…'; }
    location.href = P.routes.checkout;
  }
  function editSet() {
    closeCart();
    fpick.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var b = fpick.querySelector('.qty__b[data-act="+"]'); if (b) setTimeout(function () { try { b.focus({ preventScroll: true }); } catch (e) {} }, 350);
  }
  function removePrism() {
    var upd = {}; cartPrism().forEach(function (it) { upd[it.key] = 0; });
    if (!Object.keys(upd).length) return;
    run(function () { return post(P.routes.update, { updates: upd }).then(okOrThrow).then(refresh).then(dropLoneBumps); },
        function () { try { el('hh-close').focus({ preventScroll: true }); } catch (e) {} });
  }
  // add-ons never ride alone: once nothing else is in the cart, take them out too
  function dropLoneBumps() {
    var list = items(); if (!list.length || list.some(function (it) { return !isBump(it); })) return;
    var upd = {}; list.forEach(function (it) { upd[it.key] = 0; });
    return post(P.routes.update, { updates: upd }).then(okOrThrow).then(refresh);
  }
  function changeLine(key, qn) {
    qn = Math.max(0, Math.min(10, Math.round(Number(qn))));
    if (!isFinite(qn)) { renderCart(); return; }
    run(function () { return post(P.routes.change, { id: String(key), quantity: qn }).then(okOrThrow).then(function (c) { CART = c; }).then(dropLoneBumps); },
        function () {                              // the clicked button was re-drawn: keep keyboard focus inside the drawer
          var row = el('hh-lines').querySelector('[data-hh-key="' + String(key).replace(/"/g, '') + '"]'), b = row && row.querySelector('.hhci__b:not([disabled])');
          try { (b || el('hh-close')).focus({ preventScroll: true }); } catch (e) {}
        });
  }
  function stepBottle(n, dir) {                    // the bottle stepper: swap the one bottle line to n bottles (one write in flight)
    if (busy || !botByN(n)) return;
    var moved = false;
    run(function () { return swapBottle(n).catch(function (err) { if (err && err.moved) moved = true; throw err; }); },
        function () {
          if (moved) { setTimeout(function () { location.reload(); }, 1200); return; }
          var st = el('hh-lines').querySelector('[data-hh-bottle]');   // the line was re-drawn under a new key: focus the same button
          var b = (st && (st.querySelector('[data-dir="' + dir + '"]:not([disabled])') || st.querySelector('.hhci__b:not([disabled])'))) || el('hh-close');
          try { b.focus({ preventScroll: true }); } catch (e) {}
        });
  }
  function toggleUpsell(tag, want) {
    var b = P.bumps[tag]; if (!b) return;
    function refocus() { var bx = el('hh-upslist').querySelector('[data-hh-up="' + tag + '"] input'); if (bx) try { bx.focus({ preventScroll: true }); } catch (e) {} }
    var have = items().filter(function (it) { return Number(it.variant_id) === Number(b.id); })[0];
    if (want && !have) run(function () { return post(P.routes.add, { items: [{ id: b.id, quantity: 1 }] }).then(okOrThrow).then(refresh); }, refocus);
    else if (!want && have) run(function () { return post(P.routes.change, { id: String(have.key), quantity: 0 }).then(okOrThrow).then(function (c) { CART = c; }); }, refocus);
    else { renderCart(); refocus(); }
  }

  document.getElementById('atc').onclick = addSet;
  document.getElementById('stAtc').onclick = addSet;
  var sb = document.querySelector('[data-scroll-buy]'); if (sb) sb.onclick = function () { document.getElementById('buy').scrollIntoView({ behavior: 'smooth', block: 'start' }); };
  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var buy = t.closest('[data-hh-buy]'); if (buy) { e.preventDefault(); expressBuy(); return; }
    if (t.closest('[data-hh-open]')) { var o = t.closest('[data-hh-open]'); refresh().catch(function () {}).then(function () { openCart(o); }); return; }
    if (t.closest('#hh-close') || t.closest('#hh-scrim')) { closeCart(); return; }
    if (busy) return;
    if (t.closest('#hh-checkout')) { goCheckout(); return; }
    if (t.closest('[data-hh-edit]')) { editSet(); return; }
    if (t.closest('[data-hh-prism-rm]')) { removePrism(); return; }
    if (t.closest('[data-hh-shop]')) { closeCart(); document.getElementById('buy').scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
    var bs = t.closest('[data-hh-bstep]'); if (bs) { if (!bs.disabled) stepBottle(Number(bs.getAttribute('data-hh-bstep')), bs.getAttribute('data-dir')); return; }   // bottle stepper
    var qb = t.closest('[data-hh-q]'); if (qb) { var row = qb.closest('[data-hh-key]'); if (row) changeLine(row.getAttribute('data-hh-key'), qb.getAttribute('data-hh-q')); }
  });
  document.addEventListener('change', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var up = t.closest('[data-hh-up]'); if (up) { toggleUpsell(up.getAttribute('data-hh-up'), t.checked); return; }
    if (t.hasAttribute('data-hh-qty')) {           // same rule as the live drawer: a cleared or zero box reverts, it never deletes
      var row = t.closest('[data-hh-key]'); if (!row) return;
      var v = Math.round(Number(t.value)); if (!isFinite(v) || v < 1) { renderCart(); return; }
      changeLine(row.getAttribute('data-hh-key'), Math.min(10, v));
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && cartOpen()) closeCart(); });

  /* ---------- sticky bar: only once the real button has scrolled away ---------- */
  var sticky = document.getElementById('sticky'), mainAtc = document.getElementById('atc');
  function syncSticky() { sticky.classList.toggle('on', mainAtc.getBoundingClientRect().bottom < 0); }
  window.addEventListener('scroll', syncSticky, { passive: true });
  window.addEventListener('resize', syncSticky);

  // Back from checkout restores this page from the bfcache with busy still set — reset it and re-read the cart
  var GOHTML = el('hh-checkout') ? el('hh-checkout').innerHTML : '';
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    setBusy(false);
    if (walnote) { walnote.textContent = WALNOTE; walnote.classList.remove('fired'); }
    var gb = el('hh-checkout'); if (gb && GOHTML) gb.innerHTML = GOHTML;
    refresh().then(guardOrphans).then(normalizeBottles).catch(function () {}).then(renderCart);
  });

  render(); syncSticky();
  refresh().then(guardOrphans).then(normalizeBottles).then(function () { adoptCartSet(); renderCart(); }).catch(function () { renderCart(); });
})();
